var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.navigation)?_c('nav',{staticClass:"navigation",class:{ 'is-scrolled': _vm.isScrolled }},[_c('NavigationDesktop',{staticClass:"navigation-desktop",attrs:{"menu":_vm.navigation}}),_c('NavigationMobile',{staticClass:"navigation-mobile",attrs:{"menu":_vm.navigation}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }